import React from 'react';

import SearchField from '@app/components/Forms/SearchField/SearchField';
import { PhoneProviderContext } from '@app/components/UI/PhoneProvider/PhoneProvider';
import PhoneSVG from '@app/images/PhoneSVG';
import '@app/scss/components/findVetBlock.scss';

const FindVetBlock: React.FC = () => {
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return (
		<div className="find-vet">
			<div className="find-vet-left">
				<h3 className="find-vet-left__title">
					Find a veterinarian
					{' '}
					<span>near you</span>
				</h3>
				<SearchField placeholder="Enter your 5-digit ZIP code" iconLocation widthBorder="0" searchBody="/find-a-vet/search" />
			</div>
			<div className="find-vet-right">
				<h4 className="find-vet-right__title">Have questions? Give us a call. One of our Veterinary Care Coordinators would love to help.</h4>
				<div className="find-vet-right__availability">
					Our Lap of Love Support Center is available 24/7, every day of the year, including weekends and holidays.
				</div>
				<a className="find-vet-right__phone" href={contextPhone.state.phoneNumberHref}>
					<span className="find-vet-right__phone-icon">
						<PhoneSVG />
					</span>
					<span>{contextPhone.state.phoneNumberDisplay}</span>
				</a>
			</div>
		</div>
	);
};

export default FindVetBlock;
